module.exports = __webpack_public_path__ + "img/lounge.cfa011a4.svg";